

import {RequestField} from "../models/RequestField";
import {IPagedResults} from '../../../../core/paging/pagedResults';
import {IPagedResultsFactory} from '../../../../core/paging/pagedResultsFactory';
import '../../../../core/paging/pagedResultsFactory';
import { ITransportModeService } from './transportModeService';

import { TransportMode } from '../models/transportMode';
import { Requestor } from '../models/requestor';

export interface IRequestListService {
    getRequestFields(transportModeValue: string, searchTerm: string, isGlobalSearchAllowed : boolean, userIdReceiverFilter : string): Promise<Array<RequestField>>;
    loadMoreRequestFields(): Promise<Array<RequestField>>;
    numberOfItemsPerPage: number;
    getTransportModeFilterOptions(): Promise<Array<TransportMode>>;
    getRequestorFilterOptions(): Promise<Array<Requestor>> ;

}

export class RequestListService implements IRequestListService {
    static $inject = ['$http', 'PagedResultsFactory', 'transportModeService'];
    private _RequestResults: IPagedResults<RequestField>;
    private _numberOfItemsPerPage: number;
    

    constructor(private _$http: angular.IHttpService,
        private _pagedResultsFactory: IPagedResultsFactory,
    private _transportModeService : ITransportModeService) {
        
    }

    set numberOfItemsPerPage(value: number) {
        this._numberOfItemsPerPage = value;
    }

    getRequestFields(transportModeValue?: string,
        searchTerm?: string,
        isGlobalSearchAllowed?: boolean,
        userIdReceiverFilter ?: string): Promise<Array<RequestField>> {
        const baseUrl = `/Requests/getShipmentOrderList`;
        const parameters = {
            transportMode: transportModeValue,
            searchTerm: searchTerm,
            isGlobalSearch: isGlobalSearchAllowed,
            userIdReceiverFilter: userIdReceiverFilter
        };
        this._RequestResults = this._pagedResultsFactory
            .create<RequestField>(baseUrl, (v) => this.mapRequestFields(v), parameters, 25);
        return this._RequestResults.first();
    }

    private mapRequestFields(v: any): RequestField {
        return new RequestField(v.trackingId, v.consigneeName, v.countryName, v.createdAt, v.transportMode);
    }

    loadMoreRequestFields(): Promise<Array<RequestField>> {
        return this._RequestResults.next();
    }

    getTransportModeFilterOptions(): Promise<Array<TransportMode>> {
        
        return this._transportModeService.getTransportModes();
       
    }

    getRequestorFilterOptions(): Promise<Array<Requestor>> {
        return new Promise<Requestor[]>((resolve, reject) => {
            this._$http.get('/getRequestors')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const requestors = response.data.map(s => new Requestor(s, s));
                    resolve(requestors);
                });
        });
    }

}

angular.module('deliveryCreate.app').service('requestListService', RequestListService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/services/requestListService.ts
 **/